import { render, staticRenderFns } from "./CopyAnnotationsButton.vue?vue&type=template&id=aeec01ae&scoped=true&"
import script from "./CopyAnnotationsButton.vue?vue&type=script&lang=js&"
export * from "./CopyAnnotationsButton.vue?vue&type=script&lang=js&"
import style0 from "./CopyAnnotationsButton.vue?vue&type=style&index=0&id=aeec01ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeec01ae",
  null
  
)

component.options.__file = "CopyAnnotationsButton.vue"
export default component.exports